export const DEFAULT_PAGE = 1
export const DEFAULT_PAGES_SIZE = 15
export const DEFAULT_PRODUCT_PAGES_SIZE = 30
